export const astrologers = [
  {
    id: 1,
    name: "Dr. Rajesh Sharma",
    title: "Vedic Astrologer",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    rating: 4.9,
    reviews: 2847,
    experience: "25+ years",
    expertise: ["Vedic Astrology", "Kundli Reading", "Marriage Compatibility"],
    languages: ["English", "Hindi", "Sanskrit"],
    price: 30,
    currency: "USD",
    perMinute: true,
    status: "online",
    description: "Expert in Vedic astrology with deep knowledge of ancient scriptures. Specialized in career guidance and relationship compatibility.",
    consultations: 15000
  },
  {
    id: 2,
    name: "Acharya Priya Patel",
    title: "Tarot & Astrology Expert",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    rating: 4.8,
    reviews: 1923,
    experience: "18+ years",
    expertise: ["Tarot Reading", "Numerology", "Vastu Shastra"],
    languages: ["English", "Hindi", "Gujarati"],
    price: 25,
    currency: "USD",
    perMinute: true,
    status: "online",
    description: "Combining traditional astrology with tarot insights for accurate predictions. Known for compassionate and detailed readings.",
    consultations: 12000
  },
  {
    id: 3,
    name: "Pandit Suresh Kumar",
    title: "Jyotish Acharya",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
    rating: 4.9,
    reviews: 3456,
    experience: "30+ years",
    expertise: ["Lal Kitab", "Gemstone Recommendation", "Muhurat"],
    languages: ["English", "Hindi", "Punjabi"],
    price: 35,
    currency: "USD",
    perMinute: true,
    status: "busy",
    description: "Renowned Jyotish Acharya specializing in Lal Kitab remedies and accurate timing predictions. Government certified astrologer.",
    consultations: 20000
  },
  {
    id: 4,
    name: "Ms. Ananya Krishnan",
    title: "Nadi Astrologer",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    rating: 4.7,
    reviews: 1567,
    experience: "15+ years",
    expertise: ["Nadi Astrology", "Past Life Reading", "Spiritual Guidance"],
    languages: ["English", "Tamil", "Malayalam"],
    price: 28,
    currency: "USD",
    perMinute: true,
    status: "online",
    description: "Trained in authentic Nadi astrology from Tamil Nadu. Specializes in past life readings and karmic pattern analysis.",
    consultations: 9000
  },
  {
    id: 5,
    name: "Guru Vikram Singh",
    title: "KP Astrologer",
    image: "https://randomuser.me/api/portraits/men/76.jpg",
    rating: 4.8,
    reviews: 2134,
    experience: "20+ years",
    expertise: ["KP System", "Stock Market Astrology", "Business Astrology"],
    languages: ["English", "Hindi"],
    price: 40,
    currency: "USD",
    perMinute: true,
    status: "offline",
    description: "Expert in Krishnamurti Paddhati system. Specialized in financial astrology and business timing predictions.",
    consultations: 11000
  },
  {
    id: 6,
    name: "Dr. Meera Iyer",
    title: "Medical Astrologer",
    image: "https://randomuser.me/api/portraits/women/33.jpg",
    rating: 4.9,
    reviews: 1876,
    experience: "22+ years",
    expertise: ["Medical Astrology", "Ayurvedic Remedies", "Health Predictions"],
    languages: ["English", "Hindi", "Kannada"],
    price: 32,
    currency: "USD",
    perMinute: true,
    status: "online",
    description: "PhD in Astrology with medical specialization. Provides health predictions and Ayurvedic remedy suggestions.",
    consultations: 13000
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rahul Mehta",
    location: "Mumbai, India",
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    rating: 5,
    text: "The birth chart analysis was incredibly accurate. Dr. Sharma predicted my career change perfectly. The remedies suggested have brought positive changes in my life.",
    service: "Kundli Reading"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    location: "New York, USA",
    image: "https://randomuser.me/api/portraits/women/28.jpg",
    rating: 5,
    text: "I was skeptical at first, but the accuracy of my horoscope reading was mind-blowing. The astrologer knew things about my past that I never mentioned. Highly recommended!",
    service: "Horoscope Consultation"
  },
  {
    id: 3,
    name: "Priya Sharma",
    location: "Delhi, India",
    image: "https://randomuser.me/api/portraits/women/56.jpg",
    rating: 5,
    text: "The marriage compatibility report helped us understand each other better. The remedies suggested by Pandit ji have strengthened our relationship immensely.",
    service: "Marriage Compatibility"
  },
  {
    id: 4,
    name: "David Chen",
    location: "Singapore",
    image: "https://randomuser.me/api/portraits/men/67.jpg",
    rating: 5,
    text: "Business timing predictions were spot on! I followed the muhurat suggestions for my startup launch and the results have been phenomenal. Thank you!",
    service: "Business Astrology"
  },
  {
    id: 5,
    name: "Anita Desai",
    location: "London, UK",
    image: "https://randomuser.me/api/portraits/women/42.jpg",
    rating: 5,
    text: "The Nadi reading was a life-changing experience. Understanding my past life patterns helped me break free from recurring issues. Truly transformative!",
    service: "Nadi Astrology"
  },
  {
    id: 6,
    name: "Michael Brown",
    location: "Sydney, Australia",
    image: "https://randomuser.me/api/portraits/men/23.jpg",
    rating: 5,
    text: "The yearly horoscope predictions were incredibly detailed and accurate. Planning my year based on the insights has helped me make better decisions.",
    service: "Yearly Horoscope"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Your Birth Chart: A Complete Guide",
    slug: "understanding-birth-chart-guide",
    excerpt: "Learn how to read and interpret your natal chart, understanding the significance of planets, houses, and aspects in Vedic astrology.",
    content: "Your birth chart, also known as natal chart or Kundli, is a cosmic snapshot of the sky at the exact moment of your birth...",
    image: "https://images.unsplash.com/photo-1532968961962-8a0ff256bdb2?w=800",
    category: "Education",
    author: "Dr. Rajesh Sharma",
    date: "2024-01-15",
    readTime: "8 min read",
    tags: ["Birth Chart", "Kundli", "Vedic Astrology"]
  },
  {
    id: 2,
    title: "Mercury Retrograde 2024: What You Need to Know",
    slug: "mercury-retrograde-2024",
    excerpt: "Discover the dates, effects, and remedies for Mercury retrograde periods in 2024. Learn how to navigate this astrological phenomenon.",
    content: "Mercury retrograde is one of the most talked-about astrological events. During this period, Mercury appears to move backward...",
    image: "https://images.unsplash.com/photo-1614732414444-096e5f1122d5?w=800",
    category: "Planetary Events",
    author: "Acharya Priya Patel",
    date: "2024-01-10",
    readTime: "6 min read",
    tags: ["Mercury Retrograde", "Planets", "2024"]
  },
  {
    id: 3,
    title: "The Power of Gemstones in Vedic Astrology",
    slug: "power-of-gemstones-astrology",
    excerpt: "Explore the ancient wisdom of gemstone therapy. Learn which stones can enhance planetary energies and bring positive changes.",
    content: "Gemstones have been used for thousands of years to harness and amplify planetary energies. Each gemstone corresponds...",
    image: "https://images.unsplash.com/photo-1551122087-f99a4171c7f3?w=800",
    category: "Remedies",
    author: "Pandit Suresh Kumar",
    date: "2024-01-05",
    readTime: "10 min read",
    tags: ["Gemstones", "Remedies", "Vedic"]
  },
  {
    id: 4,
    title: "Love Compatibility: Finding Your Perfect Match",
    slug: "love-compatibility-zodiac",
    excerpt: "Understand the cosmic connections between zodiac signs. Discover which signs are most compatible for love and relationships.",
    content: "Astrological compatibility goes beyond just sun signs. To truly understand romantic compatibility, we must examine...",
    image: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=800",
    category: "Relationships",
    author: "Ms. Ananya Krishnan",
    date: "2024-01-01",
    readTime: "7 min read",
    tags: ["Love", "Compatibility", "Relationships"]
  },
  {
    id: 5,
    title: "Career Astrology: Finding Your True Calling",
    slug: "career-astrology-guide",
    excerpt: "Use your birth chart to discover your ideal career path. Learn how planetary positions influence professional success.",
    content: "Your birth chart holds valuable insights about your career potential. The 10th house, known as the house of career...",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800",
    category: "Career",
    author: "Guru Vikram Singh",
    date: "2023-12-28",
    readTime: "9 min read",
    tags: ["Career", "Professional", "Success"]
  },
  {
    id: 6,
    title: "Understanding the 12 Houses in Astrology",
    slug: "12-houses-astrology",
    excerpt: "A comprehensive guide to the 12 astrological houses and their significance in your birth chart interpretation.",
    content: "The 12 houses in astrology represent different areas of life. Each house governs specific aspects from personality to...",
    image: "https://images.unsplash.com/photo-1505506874110-6a7a69069a08?w=800",
    category: "Education",
    author: "Dr. Meera Iyer",
    date: "2023-12-25",
    readTime: "12 min read",
    tags: ["Houses", "Education", "Basics"]
  }
];

export const services = [
  {
    id: 1,
    title: "Kundli / Birth Chart",
    description: "Get your detailed birth chart analysis with planetary positions, dasha periods, and life predictions.",
    icon: "kundli",
    link: "/online-horoscope-generator",
    color: "#fbbf24"
  },
  {
    id: 2,
    title: "Daily Horoscope",
    description: "Read your daily, weekly, monthly, and yearly horoscope predictions for all zodiac signs.",
    icon: "horoscope",
    link: "/horoscope",
    color: "#8b5cf6"
  },
  {
    id: 3,
    title: "Zodiac Signs",
    description: "Explore detailed characteristics, compatibility, and traits of all 12 zodiac signs.",
    icon: "zodiac",
    link: "/zodiac",
    color: "#ec4899"
  },
  {
    id: 4,
    title: "Match Making",
    description: "Check marriage compatibility and get detailed Kundli matching reports.",
    icon: "matchmaking",
    link: "/match-making",
    color: "#f43f5e"
  },
  {
    id: 6,
    title: "Panchang",
    description: "View daily panchang, muhurat timings, and auspicious dates for important events.",
    icon: "panchang",
    link: "/panchangam",
    color: "#22c55e"
  }
];

export const dailyHoroscopes = {
  aries: {
    daily: "Today brings exciting opportunities for career advancement. Your natural leadership qualities will shine, making it an excellent day for initiating new projects. However, be mindful of your spending as Venus suggests unexpected expenses. Romance looks promising in the evening hours.",
    weekly: "This week focuses on personal growth and self-improvement. The Sun's position encourages you to step out of your comfort zone. Career matters improve mid-week, with potential for recognition. Weekend brings social opportunities and possible romantic connections.",
    monthly: "January 2024 is a transformative month for Aries. Jupiter's favorable aspect brings luck in finances and career. The first half emphasizes relationship harmony, while the second half focuses on professional achievements. Health requires attention around the 15th.",
    love: { text: "Your passionate Mars energy ignites romance today. Bold moves in love are rewarded — express your feelings directly. Singles may attract someone through their confidence and courage.", rating: 4 },
    career: { text: "Leadership opportunities arise as your ruling planet Mars empowers professional ambitions. Initiate new projects boldly. Your pioneering spirit wins admiration from colleagues and superiors.", rating: 5 },
    health: { text: "High energy levels fuel your active day. Channel excess energy into vigorous exercise. Watch for head-related tension — take breaks when pushing too hard.", rating: 4 },
    finance: { text: "Impulsive spending temptations are strong today. Mars drives quick decisions — pause before major purchases. Investments in new ventures could yield returns.", rating: 3 },
  },
  taurus: {
    daily: "Financial matters take center stage today. A practical approach to investments will yield positive results. Family relationships strengthen with meaningful conversations. Evening hours favor creative pursuits and artistic expression.",
    weekly: "The week ahead emphasizes stability and security. Professional responsibilities may increase, but rewards follow. Mid-week brings an opportunity for travel or learning. Romance flourishes for singles, while couples deepen their bond.",
    monthly: "January 2024 brings focus on home and family for Taurus. Real estate opportunities may arise early in the month. Career progress is steady, with potential for salary increase. Health and wellness routines established now will benefit long-term.",
    love: { text: "Venus blesses your love life with warmth and sensuality. Romantic dinners and thoughtful gestures strengthen bonds. Singles attract admirers through their calm, dependable nature.", rating: 5 },
    career: { text: "Steady progress marks your professional day. Your reliability earns trust from superiors. Financial and real estate sectors are especially favorable for career moves.", rating: 4 },
    health: { text: "Focus on throat and neck care today. Indulge in nourishing meals but maintain moderation. Gentle yoga or nature walks restore your earthy balance.", rating: 3 },
    finance: { text: "Financial instincts are sharp today. Venus favors luxury purchases that hold value. Long-term investments and savings plans bring security — your practical nature guides wise decisions.", rating: 5 },
  },
  gemini: {
    daily: "Communication is your superpower today. Networking brings valuable connections that could benefit your career. Short trips prove productive. Watch your words in personal relationships to avoid misunderstandings. Evening favors intellectual pursuits.",
    weekly: "A dynamic week awaits with multiple opportunities presenting themselves. Your adaptability serves you well in professional settings. Financial gains are possible mid-week. Weekend brings joy through siblings or close friends.",
    monthly: "January 2024 is intellectually stimulating for Gemini. Learning new skills or pursuing education brings satisfaction. Career changes are possible around the 20th. Relationships require honest communication. Travel opportunities appear late in the month.",
    love: { text: "Witty conversations spark romantic interest today. Your charm and humor attract potential partners. Couples benefit from playful communication — share ideas and plan new adventures together.", rating: 4 },
    career: { text: "Mercury sharpens your communication skills at work. Presentations, negotiations, and networking excel today. Multi-tasking ability impresses colleagues — juggle projects with ease.", rating: 5 },
    health: { text: "Mental stimulation is high but may cause restlessness. Balance intellectual activity with calming practices. Pay attention to nervous system — breathing exercises help center your dual nature.", rating: 3 },
    finance: { text: "Quick-thinking Mercury helps spot financial opportunities. Short-term investments and trading look promising. Avoid scattered spending across too many interests — focus your resources.", rating: 4 },
  },
  cancer: {
    daily: "Emotional intelligence guides your decisions today. Home-related matters need attention but bring satisfaction. Career shows slow but steady progress. Trust your intuition in financial decisions. Evening is perfect for self-care and relaxation.",
    weekly: "The week emphasizes emotional well-being and family connections. Professional life stabilizes, allowing focus on personal goals. Property-related decisions are favored mid-week. Romance brings comfort and security feelings.",
    monthly: "January 2024 focuses on financial security for Cancer. Savings and investments made now prove beneficial. Family relationships strengthen throughout the month. Career advancement is possible through networking. Health improves with dietary changes.",
    love: { text: "Deep emotional connections define your romantic day. The Moon heightens your nurturing instincts — show loved ones you care through acts of service. Family bonds strengthen beautifully.", rating: 5 },
    career: { text: "Your intuitive understanding of colleagues' needs builds team harmony. Home-based work or creative projects flourish. Career progress comes through emotional intelligence and care.", rating: 3 },
    health: { text: "Digestive health needs attention today. Comfort foods tempt but choose nourishing options. Water intake is essential — the Moon's influence affects your fluid balance. Rest well tonight.", rating: 3 },
    finance: { text: "Property and home investments are favored today. Your cautious nature protects against risky ventures. Savings for family security bring peace of mind — trust your gut on money matters.", rating: 4 },
  },
  leo: {
    daily: "Your charisma is at its peak today, opening doors for advancement. Creative projects receive appreciation and recognition. Love life sparkles with romantic possibilities. Avoid ego clashes at workplace. Evening entertainment brings joy.",
    weekly: "A week of celebration and recognition awaits. Your leadership abilities are noticed by superiors. Financial situation improves through unexpected sources. Social calendar fills up with exciting invitations. Romance is especially favored.",
    monthly: "January 2024 is your month to shine, Leo. Career achievements bring public recognition. Financial investments yield positive returns. Love life blossoms with potential for long-term commitment. Health benefits from outdoor activities.",
    love: { text: "The Sun illuminates your romantic sector with warmth and drama. Grand gestures of love are well-received. Your magnetic personality draws admirers — couples enjoy a spotlight moment together.", rating: 5 },
    career: { text: "Natural leadership qualities shine brightly today. Creative projects gain recognition from authority figures. The stage is set for your talents — perform with confidence and claim your deserved position.", rating: 5 },
    health: { text: "Heart health and vitality are strong today. The Sun energizes your physical activities. Outdoor exercise under sunlight is especially beneficial — your fire sign thrives with warmth and movement.", rating: 4 },
    finance: { text: "Generous spending impulses arise — balance generosity with wisdom. Investments in entertainment, creative ventures, or gold show promise. Your sunny outlook attracts financial opportunities.", rating: 4 },
  },
  virgo: {
    daily: "Analytical skills help solve complex problems at work. Health routines established today bring long-term benefits. Communication with colleagues improves productivity. Evening favors organizing and planning for future goals.",
    weekly: "The week brings focus to health and daily routines. Work projects require detailed attention but succeed with your approach. Financial planning helps secure future goals. Relationships improve through practical support.",
    monthly: "January 2024 emphasizes self-improvement for Virgo. Professional skills enhancement brings career opportunities. Health goals are achievable with disciplined approach. Relationships deepen through service to loved ones. Travel is possible late month.",
    love: { text: "Thoughtful gestures speak louder than grand declarations today. Show love through practical support and attention to detail. Singles may find connection through shared intellectual interests.", rating: 3 },
    career: { text: "Mercury enhances your analytical precision at work. Detail-oriented tasks yield excellent results. Your organizational skills solve problems others overlook — efficiency earns recognition.", rating: 5 },
    health: { text: "Health consciousness peaks today — perfect for starting new wellness routines. Digestive health benefits from mindful eating. Your earth sign nature responds well to herbal remedies and structured exercise.", rating: 5 },
    finance: { text: "Meticulous budgeting pays off today. Mercury sharpens your financial analysis — review investments and accounts for hidden savings. Practical purchases over luxury bring lasting satisfaction.", rating: 4 },
  },
  libra: {
    daily: "Relationships take center stage with potential for deeper connections. Business partnerships prove beneficial. Creative endeavors receive support and appreciation. Balance work and personal life for optimal results.",
    weekly: "The week focuses on partnerships and collaborations. Business ventures initiated now have success potential. Romance flourishes with meaningful connections. Financial matters improve through joint ventures. Social life is active and fulfilling.",
    monthly: "January 2024 brings relationship harmony for Libra. Marriage prospects are strong for singles. Business partnerships solidify and prosper. Career advancement comes through teamwork. Artistic pursuits bring recognition and possibly income.",
    love: { text: "Venus brings harmony and beauty to your relationships today. Romantic connections deepen through balanced give-and-take. Singles attract partners who appreciate grace and diplomacy.", rating: 5 },
    career: { text: "Partnership and collaboration drive career success today. Your diplomatic skills resolve workplace conflicts effortlessly. Business negotiations favor balanced, fair-minded approaches.", rating: 4 },
    health: { text: "Balance is key to your well-being today. Lower back and kidney health need attention. Harmonious activities like partner yoga or dancing keep you centered and energized.", rating: 3 },
    finance: { text: "Venus favors beauty and art investments. Joint financial ventures with partners show promise. Your balanced approach to spending and saving creates sustainable financial harmony.", rating: 4 },
  },
  scorpio: {
    daily: "Transformation energy surrounds you today. Deep insights lead to important decisions. Financial matters, especially joint resources, need attention. Research and investigation yield valuable discoveries. Evening brings spiritual insights.",
    weekly: "A week of deep transformation and growth awaits. Hidden matters come to light, bringing clarity. Financial improvements are possible through inheritance or partner's resources. Relationships intensify with passionate connections.",
    monthly: "January 2024 is transformative for Scorpio. Career changes bring long-desired improvements. Financial situation strengthens through multiple sources. Relationships undergo positive transformation. Health benefits from holistic approaches.",
    love: { text: "Intense emotional depth defines your romantic connections today. Passion and loyalty create unbreakable bonds. Trust issues may surface — face them head-on for transformative relationship growth.", rating: 4 },
    career: { text: "Your investigative mind uncovers hidden opportunities at work. Research and strategic planning yield powerful results. Transformative career moves are favored — embrace change fearlessly.", rating: 4 },
    health: { text: "Detoxification and regeneration are your health themes today. Emotional healing is as important as physical wellness. Intense workouts release stored tension — transform stress into strength.", rating: 3 },
    finance: { text: "Joint finances and shared resources need strategic attention. Insurance, inheritance, or investment returns are favored. Your ability to see beneath the surface reveals profitable hidden opportunities.", rating: 5 },
  },
  sagittarius: {
    daily: "Adventure calls today with opportunities for expansion. Learning new things brings satisfaction and opens doors. International connections prove beneficial. Optimism attracts positive circumstances. Evening favors philosophical discussions.",
    weekly: "The week brings expansion in multiple areas of life. Travel opportunities arise mid-week. Higher education or legal matters progress favorably. Financial luck improves through foreign connections. Romance brings exciting adventures.",
    monthly: "January 2024 expands horizons for Sagittarius. Travel opportunities, possibly international, appear early month. Educational pursuits bring success and recognition. Career benefits from foreign connections or publications. Love life is adventurous and exciting.",
    love: { text: "Adventure and excitement spark your romantic life today. Jupiter brings optimism to relationships. Long-distance connections thrive — shared philosophical beliefs create deep bonds with your partner.", rating: 4 },
    career: { text: "Jupiter expands professional horizons with international opportunities. Teaching, publishing, and higher education ventures excel. Your optimistic vision inspires teams and attracts supportive mentors.", rating: 5 },
    health: { text: "Outdoor adventures and travel energize your fire sign spirit. Hip and thigh exercises are especially beneficial. Jupiter's influence encourages overindulgence — maintain moderation in all things.", rating: 4 },
    finance: { text: "Jupiter brings fortunate financial expansion today. International investments and educational ventures show returns. Your optimistic outlook attracts abundance — but avoid over-extending commitments.", rating: 4 },
  },
  capricorn: {
    daily: "Career ambitions receive cosmic support today. Practical efforts yield tangible results. Authority figures notice your dedication. Financial planning for long-term security is favored. Evening is best for family time.",
    weekly: "The week emphasizes professional achievements and recognition. Hard work from the past begins paying off. Financial stability increases through wise decisions. Relationships benefit from your increased availability.",
    monthly: "January 2024 is career-focused for Capricorn. Promotions and recognition are possible. Financial security improves significantly. Relationships require attention amidst professional success. Health benefits from structured routines.",
    love: { text: "Saturn's discipline brings commitment and stability to relationships. Long-term partnerships strengthen through shared responsibilities. Romance may feel reserved but runs deep — loyalty is your love language.", rating: 3 },
    career: { text: "Saturn rewards your hard work and discipline with career advancement today. Authority figures recognize your dedication. Structured planning leads to tangible professional achievements and promotions.", rating: 5 },
    health: { text: "Bone and joint health deserve attention today. Structured exercise routines bring lasting benefits. Saturn's influence favors discipline — consistent healthy habits yield cumulative results over time.", rating: 3 },
    finance: { text: "Conservative financial strategies pay off handsomely. Saturn rewards long-term savings and disciplined investments. Real estate and traditional assets are highly favorable for wealth building.", rating: 5 },
  },
  aquarius: {
    daily: "Innovation and originality set you apart today. Social connections bring unexpected opportunities. Humanitarian interests inspire meaningful action. Technology-related ventures show promise. Evening favors group activities.",
    weekly: "The week brings exciting opportunities through social networks. Innovative ideas receive support and recognition. Financial gains through technology or unique ventures are possible. Friendships deepen with meaningful connections.",
    monthly: "January 2024 highlights social connections for Aquarius. Networking brings career opportunities. Financial gains through innovative ventures are possible. Relationships benefit from shared humanitarian interests. Health improves through alternative approaches.",
    love: { text: "Unconventional romantic approaches work best today. Intellectual connection matters more than tradition. Friendships may evolve into deeper relationships — your unique perspective attracts like-minded souls.", rating: 4 },
    career: { text: "Innovation and technology drive career breakthroughs today. Uranus sparks revolutionary ideas that impress forward-thinking organizations. Group projects and humanitarian ventures bring fulfillment and recognition.", rating: 5 },
    health: { text: "Circulation and ankle health need attention today. Alternative healing methods resonate with your progressive nature. Group fitness or community wellness activities boost both physical and social well-being.", rating: 3 },
    finance: { text: "Technology and innovation investments show strong potential. Cryptocurrency and digital ventures align with your forward-thinking nature. Unexpected financial gains come through networking and group ventures.", rating: 4 },
  },
  pisces: {
    daily: "Intuition is your guide today. Creative and artistic pursuits bring satisfaction. Spiritual practices provide clarity and peace. Career matters benefit from compassionate approach. Evening is perfect for meditation and reflection.",
    weekly: "The week emphasizes spiritual growth and creative expression. Intuitive insights guide important decisions. Career progress through creative industries is possible. Relationships deepen through emotional connections.",
    monthly: "January 2024 is spiritually significant for Pisces. Creative projects bring recognition and possibly income. Career benefits from intuitive decision-making. Relationships experience profound emotional bonding. Health improves through spiritual practices.",
    love: { text: "Neptune fills your romantic world with dreamy possibilities. Soulmate connections feel especially strong today. Creative expressions of love — poetry, music, art — touch your partner's heart deeply.", rating: 5 },
    career: { text: "Creative and intuitive work excels today. Neptune inspires artistic projects and compassionate leadership. Healing professions, music, and visual arts bring both fulfillment and recognition.", rating: 4 },
    health: { text: "Feet and lymphatic system need gentle care today. Water-based activities — swimming or hydrotherapy — restore your energy. Meditation and spiritual practices heal both body and soul.", rating: 4 },
    finance: { text: "Intuitive financial decisions prove accurate today. Charitable giving brings karmic returns. Creative ventures generate income — trust your artistic instincts but verify details with practical analysis.", rating: 3 },
  }
};

export const stats = {
  users: "2,50,000+",
  astrologers: "500+",
  horoscopes: "10,00,000+",
  countries: "50+"
};

export const faqs = [
  {
    question: "How accurate are the horoscope predictions?",
    answer: "Our predictions are based on authentic Vedic astrology principles and calculated using precise astronomical data. While astrology provides guidance based on planetary positions, free will plays a significant role in shaping outcomes. Our expert astrologers have years of experience and high accuracy rates."
  },
  {
    question: "What information do I need for a birth chart?",
    answer: "To generate an accurate birth chart (Kundli), you need your exact date of birth, time of birth (as precise as possible), and place of birth. The time of birth is crucial as it determines your Ascendant (Lagna) and house positions."
  },
  {
    question: "What payment methods do you accept?",
    answer: "We accept all major credit/debit cards, UPI, net banking, and popular digital wallets. All transactions are secured with industry-standard encryption for your safety."
  },
  {
    question: "Can I get a refund if I'm not satisfied?",
    answer: "Yes, we have a satisfaction guarantee policy. If you're not satisfied with our services, you can reach out to us through the contact page. Terms and conditions apply."
  }
];
